// extracted by mini-css-extract-plugin
module.exports = {"container":"Tm","bubbleNav":"Um","graphic":"Vm","container404":"Wm","container500":"Xm","contact":"Ym"};